import { SalesforceAccountProductBundle } from '@weave/schema-gen-ts/dist/schemas/salesforce/v1/salesforce.pb';
import { Feature } from '@weave/schema-gen-ts/dist/shared/feature/location_feature.pb';
import { contextFactory } from '@frontend/design-system';
import { LocationSubscriptionData } from '../types';

export interface FeatureSubscriptionContextProps {
  selectedLocationIds: string[];
  isUpgradeOrTrialEligible: boolean;
  isFreeTrialEligible: boolean;
  isUpgradeEligible: boolean;
  isSelfSubscribeEligible: boolean;
  feature: Feature;
  isLoading: boolean;
  invalidateSubscriptionConfig: () => void;
  subscriptionDataList: LocationSubscriptionData[];
  locationWiseAdminAccess: Record<string, boolean>;
  hasAdminAccessInAtLeastOne: boolean;
  isBundleUpgradeEligible: boolean;
  recommendedBundle: SalesforceAccountProductBundle;
}

export const [FeatureSubscriptionContext, useFeatureSubscription] = contextFactory<FeatureSubscriptionContextProps>();
